import type {UpmFilterValue, UpmHierarchyNode} from '../types'

export const groupByName = (items: UpmHierarchyNode[]): UpmFilterValue[] => {
  return Object.values(
    items.reduce<Record<string, UpmFilterValue>>((acc, item) => {
      if (!acc[item.value]) {
        acc[item.value] = {
          value: item.value,
          upmIds: [item.upmId],
          level: item.level
        }
      } else {
        acc[item.value].upmIds.push(item.upmId)
      }
      return acc
    }, {})
  )
}

export const filterByUpmIds = <T extends {upmId: string}>(items: T[], upmIds: string[]): T[] => {
  const ids = upmIds.map((id) => id.split(',')).flat()
  return ids.length ? items.filter((item) => ids.includes(item.upmId)) : items
}

export const getChildren = <T extends {children?: T[]}>(items: T[]): T[] => {
  return items.flatMap((item) => item.children ?? [])
}

export const getVisibleIds = (items: UpmFilterValue[]): string[] =>
  items.map((item) => item.upmIds.join(','))

export const pruneSelectedIds = (selectedIds: string[], visibleIds: string[]): string[] =>
  selectedIds.filter((id) => visibleIds.includes(id))
